import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandLoomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-loom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17.464 6.518a6 6 0 1 0 -3.023 7.965"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17.482 17.464a6 6 0 1 0 -7.965 -3.023"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.54 17.482a6 6 0 1 0 3.024 -7.965"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.518 6.54a6 6 0 1 0 7.965 3.024"
    }, null), _createTextVNode(" ")]);
  }
};